let url;
// console.log('NODE_ENV: ', process.env.NODE_ENV, 'location: ', location.origin);

if(location.origin === 'http://za-te.mypets-admin.local' || location.origin === 'http://localhost:8090') {
    url="http://za-te.mypets-server.local";
} else {
    url="http://mypets-laravel.za-te.net"
}
export const baseUrl = url;

// ENDPOINTS
// url - without 'public'
export const PhotoUrl = baseUrl + '/uploads/';
export const AlbumsPhotoUrl = baseUrl + '/albums/';
export const LocationsPhotoUrl = baseUrl + '/locations/';

// FRONTEND
export const ApiHome = baseUrl + '/api/home/';
export const ApiContactUs = baseUrl + '/api/home/contactSend';

// Frontend inner links
export const GalleryAlbumLink = '/galerija/album/';



// WEBPACK FOOTER //
// ./src/.env.js